<template>
  <Modal :id="'cmp-multi-order-list'" @cancelled="onCancelClick">
    <template slot="header"></template>
    
    <template slot="body">
      <div class="box-widget selected" style="margin-top: 10px">
      <div class="box-header gray">
        <div class="box-header--name">{{$t('Edit')}} {{$t('tab_title_invoice_reminder')}}</div>
      </div>
      <div class="box-body">
        <div  style="padding:10px" v-if="invoiceContacts && invoiceContacts.contact">
          {{ir_currency}} <br>
          {{invoiceContacts.contact.company_name}}
        </div>
        <!-- style="border: 1px solid var(--text-secondary);" -->
        <div style="padding:10px">
          <NTable
            class="artist-payment-list dbox1"
            :headers="ircHeaders"
            :items="invoiceContacts.invoices"
            :config="tableConfig"
            :height="'600'"
            
          >
          <template v-slot:item="{ tdcon, item }">
            <tr>
              <td v-bind="tdcon('invoice_ref')" @click="e => onInvoiceClick(item)" :title="$t('click_to_see_invoice_details')">
                <span style="font-weight:bold" class="ut-link ut-text-accent5">{{item['invoice_ref']}}</span>
              </td>
              <td v-bind="tdcon('subject')">
                <span>  {{item['subject']}} </span>
              </td>
              <td v-bind="tdcon('invoice_project')">
                <span> {{invoiceProjectName}} </span>
                
              </td>
              <td v-bind="tdcon('date')">
                <span>{{item['invoice_date']}}</span>
              </td>
              <td v-bind="tdcon('level')">
                <span>{{item['dunning_level']}}</span>
              </td>
              <td v-bind="tdcon('gross')">
                <span v-if="item['invoice_amount']" style="text-align:right" >
                  {{item['invoice_amount'] +' '}}
                  <template >{{item['currency_iso']||'EUR'}}</template>
                </span>
              </td>
              <td v-bind="tdcon('open')">
                <span v-if="item['amount_due']" style="text-align:right" >
                  {{item['amount_due'] +' '}}
                  <template>{{item['currency_iso']||'EUR'}}</template>
                </span>
                
              </td>
              <td v-bind="tdcon('options')">
                <img
                  src="static/icons/delete.svg"
                  @click.stop="e => onDeleteInvoiceContact(item)"
                  class="dt-icon v5 s1 ut-center"
                  alt
                />
              </td>
            </tr>
          </template>
          <!-- <template v-slot:tfoot="{ thcon, thtext }">
            <tr>
              <th
                v-for="header in ircHeaders"
                v-bind="thcon(header.value)"
                :key="header.value"
              >
                <div v-if="header.value=='payments'"  class="header-name">
                    {{thtext('total')}}
                </div>
                <div v-else class="header-name">
                    {{thtext(header.value)}}
                </div>
              </th>
            </tr>
          </template> -->
          <template #tfoot>
            <tr>
             
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td><span>{{$t('total')}}</span></td>
              <td > <span style="margin-left: -13px;">
                  {{ parseFloat(totalValue).toFixed(2)}} {{$t('eur')}}
                </span>
              </td>
              
              
            </tr>
          </template>
        </NTable>
        </div>
        
      </div>
    </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click="onCancelClick">{{$t('cancel')}}</button>
    </template>

  </Modal>
</template>

<script>
import NTable from "@/plugins/datatable/datatable";

import { InvoiceReminderService } from "../../services/invoice-reminder.service";
import { createNTableConfig,createTableHeader } from "../../../../plugins/datatable";
import { I18CONFIG } from '../../../../i18n/config';
import { invoiceListLDTRoutes } from '../../router/routes';
import { routeWithFrom } from '../../../../utility/route';
import Modal from "../../../../dt-plugins/modal/modal";
import { confirmDelete } from '../../../../dt-plugins/confirmation/confirmation-common';
export default {
  components: {
    NTable,
    Modal
  },
  props: {
    selectedInvoiceReminder: {
      type: Object
    }
  },
  data: function() {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: false,
        footer: true
      }),

      invoiceContacts: {}
    };
  },
  mounted: async function() {
    this.invoiceContacts = (await InvoiceReminderService.findInvoiceReminderContacts(
      {
        invoice_reminder_contact_id: this.irc_id
      }
    )).data;
    console.log("::::",this.invoiceContacts);
  },
  computed: {
    // rowNum:function(){
    //   if(this.invoiceContacts?.invoices.length){
    //     return (this.invoiceContacts?.invoices.length+2)*28
    //   }
    //   return 28*2
    // },
    irc_id: function() {
      return this.$route.query.irc_id;
    },
    ircHeaders: function () {
      return [
        createTableHeader("invoice_ref", {  text:'Invoice Ref' ,f:1.5}),
        createTableHeader("subject"),
        createTableHeader("invoice_project",{}),
        createTableHeader("date", {  }),
        createTableHeader("level", {  }),
        createTableHeader("gross", { ta:'right' , text:"Gross Payments"}),
       
        createTableHeader("open", {  ta:'right' }),
        createTableHeader("options", { text: false, mw: 30 ,ta:'center'}),

      ];
    },

    invoiceProjectName:function(){
      return this.invoiceContacts.ip.invoice_project_name
    },
    // ircHeaders: function() {
    //   return [
    //     { text: this.$t("Invoice Ref"), value: "Invoice Ref" },
    //     { text: this.$t(""), value: "subject" },
    //     { text: this.$t("invoice_project"), value: "invoice_project" },
    //     { text: this.$t("date"), value: "date" },
    //     { text: this.$t("Level"), value: "Level" },
    //     { text: this.$t("gross"), value: "gross" },
    //     { text: this.$t("payments"), value: "payments" },
    //     { text: this.$t("open"), value: "open" },
    //     { text: this.$t(" "), value: "options" }
    //   ];
    // },
    totalValue: function() {
      return (this.invoiceContacts.invoices || []).reduce(
        (accm, cur) => accm + parseInt(cur.amount_due),
        0
      );
    },
    ir_currency: function() {
      return this.invoiceContacts && this.invoiceContacts.currency && this.invoiceContacts.currency.currency_iso || I18CONFIG.CURRENCY;
    }
  },
  methods: {
    onCancelClick: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined,
          irc_id: undefined
        }
      });
    },
    onDeleteInvoiceContact: async function(item) {
      // console.log(":::",item)
      const { invoice_reminder_pos_id } = item;
      const confirmationResult = await confirmDelete(
        "invoice ref",
        item.invoice_ref
      );
      if (confirmationResult == "OK") {
        this.invoiceContacts = {
          ...this.invoiceContacts,
          invoices: this.invoiceContacts.invoices.filter(
            e => e.invoice_reminder_pos_id != item.invoice_reminder_pos_id
          ),
        };
        const deleteInvoiceReminderPos = await InvoiceReminderService.deleteInvoiceReminderPos(invoice_reminder_pos_id);
      }
    },
    onInvoiceClick: function(item) {
      const { invoice_id } = item;
      // this.$router.push({
      //   name: invoiceListLDTRoutes.names.tab,
      //   params: {
      //     invoice_id,
      //     tab: 'overview'
      //   },
      //   query: {
      //     from: encodeRoute(this.$route)
      //   }
      // });
      routeWithFrom(this, {
        name: invoiceListLDTRoutes.names.tab,
        params: {
          invoice_id,
          tab: 'overview'
        },
      })
    }
    //MARK: Methods
  }
};
</script>


<style lang="scss">
.cmp-invoice-reminder-contacts-edit {
  // .dt-ntable {
  //   --ntable-height: 800px !important;

  //   th:nth-child(1),
  //   td:nth-child(1) {
  //     font-weight: 700;
  //     cursor: pointer;

  //     &:hover {
  //       text-decoration: underline;
  //     }
  //   }

  //   th:nth-child(9),
  //   td:nth-child(9) {
  //     flex: 0.2;
  //   }

  //   @media (min-width: 320px) and (max-width: 480px) {
  //     th:nth-child(2),
  //     td:nth-child(2),
  //     th:nth-child(3),
  //     td:nth-child(3),
  //     th:nth-child(4),
  //     td:nth-child(4),
  //     th:nth-child(5),
  //     td:nth-child(5) {
  //       display: none !important;
  //     }
  //   }
  // }

  @media screen and (min-width: 320px) and (max-width: 480px) {

    .dt-modal--title-bar {
      margin-top: 0px !important;
    }
    .dt-ntable {
      --ntable-height: 510px !important;
    }
  }
}
</style>